export default "__VITE_ASSET__CtkJHN$A__"